export const SignatureRouting = [
  {
    path: "/platform-electronic-visa/signature/:type",
    name: "signatureAll",
    component: () => import("@/views/platform-electronic-visa/signature/index.vue"),
    meta: { title: "签署列表", icon: "dashboard" },
  },
  {
    path: "/platform-electronic-visa/signature/add",
    name: "signatureAdd",
    component: () => import("@/views/platform-electronic-visa/signature/add/index.vue"),
    meta: { title: "发起签署", icon: "dashboard" },
  },
  {
    path: "/platform-electronic-visa/signature/signature",
    name: "signatureSignature",
    component: () => import("@/views/platform-electronic-visa/signature/add/signature.vue"),
    meta: { title: "合同签署", icon: "dashboard" },
  },
  {
    path: "/platform-electronic-visa/signature/detail",
    name: "signatureDetail",
    component: () => import("@/views/platform-electronic-visa/signature/detail/index.vue"),
    meta: { title: "合同详情", icon: "dashboard" },
  },
];

export const SignatureLink = [
  {
    path: "/platform-electronic-visa/signature/signlink",
    name: "signlink",
    component: () => import("@/views/platform-electronic-visa/signature/sign-link/index.vue"),
    meta: { title: "签署", icon: "dashboard" },
  },
  {
    path: "/platform-electronic-visa/signature/sign-mobile",
    name: "signMobile",
    component: () => import("@/views/platform-electronic-visa/signature/sign-mobile/index.vue"),
    meta: { title: "认证", icon: "dashboard" },
  },
  {
    path: "/platform-electronic-visa/signature/sign-mobile-complete",
    name: "signMobileComplete",
    component: () => import("@/views/platform-electronic-visa/signature/sign-complete/mobile.vue"),
    meta: { title: "认证结果", icon: "dashboard" },
  },
  {
    path: "/platform-electronic-visa/signature/sign-complete",
    name: "signComplete",
    component: () => import("@/views/platform-electronic-visa/signature/sign-complete/completeUrl.vue"),
    meta: { title: "签署结果", icon: "dashboard" },
  },
];
